
define('template!sdcBarGraph',[''],function(template){return '<div ng-repeat="item in items">\r\n\t<div>\r\n\r\n\t</div>\r\n</div>';});

